import * as React from 'react';

const Oidc = () => (
  <div>
    <h1>This is a Custom Callback component</h1>
  </div>
);

export default Oidc;